<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 32.977 31.977">
        <g id="serial_number" data-name="serial number" transform="translate(-75 -201)">
            <g id="Group_2707" data-name="Group 2707" transform="translate(29 27)">
                <circle id="Ellipse_46" data-name="Ellipse 46" cx="13.5" cy="13.5" r="13.5"
                        transform="translate(46 174)" fill="#c0d0fc" opacity="0.7"/>
            </g>
            <g id="countdown" transform="translate(82.023 207.023)">
                <path id="Path_70073" data-name="Path 70073"
                      d="M22.153,3.8A12.977,12.977,0,0,0,3.8,22.153,12.977,12.977,0,0,0,22.153,3.8ZM12.977,24.433A11.456,11.456,0,1,1,24.433,12.977,11.469,11.469,0,0,1,12.977,24.433Z"
                      fill="#799cfb"/>
                <path id="Path_70074" data-name="Path 70074"
                      d="M80.009,70.124H76.968a.76.76,0,0,0-.76.76,5.323,5.323,0,1,1-5.323-5.323.76.76,0,0,0,.76-.76V61.76a.76.76,0,0,0-.76-.76,9.885,9.885,0,1,0,9.885,9.885A.76.76,0,0,0,80.009,70.124Zm-9.124,9.124a8.364,8.364,0,0,1-.76-16.694v1.528a6.843,6.843,0,1,0,7.562,7.562h1.528A8.375,8.375,0,0,1,70.885,79.249Z"
                      transform="translate(-57.908 -57.908)" fill="#799cfb"/>
                <path id="Path_70075" data-name="Path 70075"
                      d="M211.043,182.84a.76.76,0,1,0,1.492.293.761.761,0,1,1,.746.909.76.76,0,1,0,0,1.521.76.76,0,1,1-.753.867.773.773,0,0,1-.007-.107.76.76,0,1,0-1.521,0,2.281,2.281,0,0,0,4.562,0,2.272,2.272,0,0,0-.583-1.521,2.281,2.281,0,1,0-3.937-1.962Z"
                      transform="translate(-200.304 -171.825)" fill="#799cfb"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ISerial",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
